import styled from 'styled-components'

export const ProjectCardListItem = styled.li`
  list-style-type: none;
  height: 260px;
  width: 260px;
  background-color: #ffffff;
  border-radius: 15px;
  margin-right: 20px;
  margin-bottom: 20px;
  border: 1px solid #cbd5e1;
`

export const ProjectCardImage = styled.img`
  width: 100%;
  height: 200px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
`

export const ProjectCardName = styled.p`
  font-family: 'Roboto';
  font-weight: bold;
  font-size: 18px;
  padding-left: 20px;
`
